module.exports = __webpack_public_path__ + "static/img/baoxue.22cb38a5.png";